import dayjs from "dayjs";
import { postGeoAdd } from "tm-shared/api";

import { getPreciseLocation } from "@/utils/geo/geo";

export const sendUserLocation = async (): Promise<void> => {
    const locationTime = dayjs().toISOString();

    try {
        const { accuracy, lat, lng } = await getPreciseLocation();

        await postGeoAdd({
            accuracy,
            locationTime,
            latitude: lat,
            longitude: lng,
        });
    } catch (error) {
        console.error("Failed to send location:", error);
    }
};
